module.exports = __webpack_public_path__ + "static/52-1eab60770c971e497bcce9a26a555083.png";